module.exports = "/_next/static/images/921f6141a19461ac6f4a33e05dd888f1-woman-holding-card-smiling-2@desktop1024.png.webp";